import { QuestionAnswerInterface } from "ApiGen/CustomerVerificationV2/model/models";

export class QuestionAnswer implements QuestionAnswerInterface { 
   
    public questionType: string;
    public questionAnswer: string;

    constructor(questionType: string, questionAnswer: string){
        this.questionType = questionType;
        this.questionAnswer = questionAnswer;
    };
}